const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Converts an external cover image URL to use our backend proxy.
 * This ensures covers are cached locally and not dependent on external CDNs
 * (OpenLibrary, Amazon) which can serve wrong images in different regions.
 */
export function proxyCoverUrl(url) {
  if (!url) return null;
  // Already a local/relative path — serve as-is
  if (url.startsWith('/')) return url;
  // External URL — route through our proxy
  if (url.startsWith('http')) {
    return `${BACKEND_URL}/api/cover-proxy?url=${encodeURIComponent(url)}`;
  }
  return url;
}
